import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hello, I'm Ammar Jabakji - React Native Developer.`}</h1>
    <p>{`With more than 12 years of experience in web and mobile app development, I am a skilled and versatile React Native developer who can deliver high-quality solutions using cutting-edge technologies such as React.js, React Native, TypeScript, Gatsby, GraphQL, Headless CMS, and Apollo, I excel in delivering high-quality solutions using cutting-edge technologies. My expertise extends to full-stack development, automation, testing, system and data analysis, DevOps lifecycle, public cloud services (Azure, AWS), and server setup and security.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      